<template>
    <section class="zippyking-wrapper relative xl:pt-spc31 lg:pt-spc31 pt-spc31 md:pt-spc23 pb-spc37">

        <!-- popup videos -->
        <div class="video-popup flex items-center justify-center fixed left-0 opacity-0 invisible w-full h-full" :class="{'active': isVideo1}">
            <div class="video-popup-bg absolute left-0 top-0 w-full h-full " v-on:click="isVideo1Toggle"></div>
            <div class="video-popup-wrap relative w-full max-w-1440px">
                <span class="close-btn absolute right-0 top-0" v-on:click="isVideo1Toggle">
                  +
                </span>
                <iframe class="w-full h-spc32" src="https://www.youtube.com/embed/t3tsMEhlvwM" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen ></iframe>
            </div>
        </div>
        <!-- video 2 -->
        <div class="video-popup flex items-center justify-center fixed left-0 opacity-0 invisible w-full h-full" :class="{'active': isVideo2}">
            <div class="video-popup-bg absolute left-0 top-0 w-full h-full " v-on:click="isVideo2Toggle"></div>
            <div class="video-popup-wrap relative w-full max-w-1440px">
                <span class="close-btn absolute right-0 top-0" v-on:click="isVideo2Toggle">
                  +
                </span>
                <iframe class="w-full h-spc32" src="https://www.youtube.com/embed/-YQF1VUMBqs" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen ></iframe>
            </div>
        </div>
        <!-- video 3 -->
        <div class="video-popup flex items-center justify-center fixed left-0 opacity-0 invisible w-full h-full" :class="{'active': isVideo3}">
            <div class="video-popup-bg absolute left-0 top-0 w-full h-full " v-on:click="isVideo3Toggle"></div>
            <div class="video-popup-wrap relative w-full max-w-1440px">
                <span class="close-btn absolute right-0 top-0" v-on:click="isVideo3Toggle">
                  +
                </span>
                <iframe class="w-full h-spc32" src="https://www.youtube.com/embed/5kDbTV3qcfk" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen ></iframe>
            </div>
        </div>

        <div class="wrapper max-w-1440px ml-auto mr-auto xl:px-0 lg:px-0 md:px-spc2">
            <div class="zippykind-content-box text-white">
                <h1 v-if="title" class="whitespace-pre-line xl:text-size3 lg:text-size3 text-size3 md:text-2xl xl:leading-spc5 lg:leading-spc5 leading-spc5 md:leading-spc10">
                    {{title}}
                </h1>
                <div class="zippykind-grid grid mt-spc12">
                    <div class="zippykind-item xl:mb-0 lg:mb-0 md:mb-spc41">
                        <div class="zippykind-img relative">
                            <a href="#" v-on:click="isVideo1Toggle" class="block">
                                <img :src="require('@/assets/images/zippykind-1.jpg')" alt="">
                                <span class="overlay opacity-0 invisible absolute left-0 top-0 w-full h-full flex items-center justify-center text-size5">
                                    <font-awesome-icon :icon="['fa', 'play']" />
                                </span>
                            </a>
                        </div>
                        <h2 class="xl:leading-spc6 lg:leading-spc6 leading-spc6 md:leading-spc6 xl:text-size4 lg:text-size4 text-size4 md:text-xl xl:mt-6 lg:mt-6 mt-6 md:mt-5 opacity-80">
                            Customer View
                        </h2>
                    </div>
                    <div class="zippykind-item xl:mb-0 lg:mb-0 md:mb-spc41">
                        <div class="zippykind-img relative">
                            <a href="#" v-on:click="isVideo2Toggle" class="block">
                                <img :src="require('@/assets/images/zippykind-2.jpg')" alt="">
                                <span class="overlay opacity-0 invisible absolute left-0 top-0 w-full h-full flex items-center justify-center text-size5">
                                    <font-awesome-icon :icon="['fa', 'play']" />
                                </span>
                            </a>
                        </div>
                        <h2 class="xl:leading-spc6 lg:leading-spc6 leading-spc6 md:leading-spc6 xl:text-size4 lg:text-size4 text-size4 md:text-xl xl:mt-6 lg:mt-6 mt-6 md:mt-5 opacity-80">
                            Driver View
                        </h2>
                    </div>
                    <div class="zippykind-item">
                        <div class="zippykind-img relative">
                            <a href="#" v-on:click="isVideo3Toggle" class="block">
                                <img :src="require('@/assets/images/zippykind-3.jpg')" alt="">
                                <span class="overlay opacity-0 invisible absolute left-0 top-0 w-full h-full flex items-center justify-center text-size5">
                                    <font-awesome-icon :icon="['fa', 'play']" />
                                </span>
                            </a>
                        </div>
                        <h2 class="xl:leading-spc6 lg:leading-spc6 leading-spc6 md:leading-spc6 xl:text-size4 lg:text-size4 text-size4 md:text-xl xl:mt-6 lg:mt-6 mt-6 md:mt-5 opacity-80">
                            Backend Dispatch View
                        </h2>
                    </div>

                </div>
            </div>
        </div>
    </section>
</template>

<script>

    export default {
        name: "Zippykind",
        data() {
            return {
                title: "See How Zippykind Looks Through the \nEyes of a Customer, Driver and Staff!",
                isVideo1: false,
                isVideo2: false,
                isVideo3: false,
            }
        },
        methods: {
            isVideo1Toggle(e) {
                e.preventDefault();
                this.isVideo1 = !this.isVideo1;
            },
            isVideo2Toggle(e) {
                e.preventDefault();
                this.isVideo2 = !this.isVideo2;
            },
            isVideo3Toggle(e) {
                e.preventDefault();
                this.isVideo3 = !this.isVideo3;
            },
        }
    }
</script>

<style scoped>

</style>